export default __webpack_public_path__ + "static/Composite_mid_scalebar_pos88-e1b8b1704046115bf58cd132ef981a88.png";